export default __webpack_public_path__ + "static/media/Bracers of the Cloudcleaver.f9635f56.jpg";